import { useDispatch, useSelector } from 'react-redux'
import EnrollmentsListIndex from './List'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { getClients, getRoles } from 'store/lookup'
import { search as getEnrollments } from 'store/person/enrollment'
import EnrollmentsFormIndex from './Form'
import { BasePathProvider } from 'components/Providers'
import { Drawer } from '@mui/material'

export default function EnrollmentsPage() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { personId, enrollmentId } = useParams()
  const enrollments = useSelector(state => state.person2?.enrollments && state.person2.enrollments[+personId])
  const basePath = `/people/staff/${personId}/campus/`
  const districtTypes = useSelector(state => state.lookup.types).filter(t => t.category === 'districtType')
  const { clients } = useSelector(state => state.lookup)
  const roles = useSelector(state => state.lookup.roles)
  const campuses = clients?.flatMap(item =>
    (item.client?.schools || []).flatMap(school =>
      (school.campuses || []).map(campus => ({ ...campus, type: item.client?.type }))
    )
  ) || []


  useEffect(() => {
    if (clients == null) dispatch(getClients())
  }, [clients, dispatch])

  useEffect(() => {
    if (!roles) dispatch(getRoles())
  }, [roles, dispatch])


  useEffect(() => {
    enrollments || dispatch(getEnrollments({ personId: +personId }))
  }, [dispatch, personId, enrollments])

  if (!(campuses && enrollments)) return null

  return (
    <BasePathProvider value={`${basePath}`}>
      <EnrollmentsListIndex enrollments={enrollments} campuses={campuses} districtTypes={districtTypes} />
      <Drawer
        PaperProps={{
          sx: {
            width: 800,
          },
        }}
        open={Boolean(enrollmentId)}
        anchor="right"
        onClose={() => navigate(`${basePath}`)}
      >
        <EnrollmentsFormIndex enrollments={enrollments} campuses={campuses} districtTypes={districtTypes} />
      </Drawer>
    </BasePathProvider>
  )
}
